// Locales soportados
export const SUPPORTED_LOCALES = ['en', 'es', 'de', 'fr', 'nl', 'sv', 'no', 'da', 'fi'];

// Mapa de dirección de texto por locale
export const LOCALE_DIRECTION_MAP = {
  en: 'ltr',
  es: 'ltr',
  de: 'ltr',
  fr: 'ltr',
  nl: 'ltr',
  sv: 'ltr',
  no: 'ltr',
  da: 'ltr',
  fi: 'ltr',
};

// Opciones para el selector de idioma (bandera + nombre nativo)
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: '🇬🇧 English', flag: '🇬🇧', nativeName: 'English' },
  { value: 'es', label: '🇪🇸 Español', flag: '🇪🇸', nativeName: 'Español' },
  { value: 'de', label: '🇩🇪 Deutsch', flag: '🇩🇪', nativeName: 'Deutsch' },
  { value: 'fr', label: '🇫🇷 Français', flag: '🇫🇷', nativeName: 'Français' },
  { value: 'nl', label: '🇳🇱 Nederlands', flag: '🇳🇱', nativeName: 'Nederlands' },
  { value: 'sv', label: '🇸🇪 Svenska', flag: '🇸🇪', nativeName: 'Svenska' },
  { value: 'no', label: '🇳🇴 Norsk', flag: '🇳🇴', nativeName: 'Norsk' },
  { value: 'da', label: '🇩🇰 Dansk', flag: '🇩🇰', nativeName: 'Dansk' },
  { value: 'fi', label: '🇫🇮 Suomi', flag: '🇫🇮', nativeName: 'Suomi' },
];

// Extraer código base de un locale con región (es-ES → es)
export const extractBaseLocale = (localeString) => {
  if (!localeString || typeof localeString !== 'string') return 'en';
  const base = localeString.split('-')[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(base) ? base : 'en';
};
